"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appRequest = appRequest;
exports.createPath = createPath;
exports.getErrorMessage = getErrorMessage;
exports.isInvalidSession = isInvalidSession;
exports.isUnprivilegedUser = isUnprivilegedUser;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function isInvalidSession(error) {
  var _error$response;
  return (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401;
}
function isUnprivilegedUser(error) {
  var _error$response2;
  return (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 403;
}
function appRequest(config) {
  let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  let body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  let headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let timeout = 60000;
  if (config.timeout !== undefined) {
    timeout = config.timeout;
  }
  const defaults = {
    method,
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    data: body,
    timeout: timeout
  };
  const finalConfig = (0, _lodash.merge)({}, defaults, config);
  // make request
  return _axios.default.request(finalConfig);
}
function getErrorMessage(err) {
  var _err$response;
  // if api returns an error message, use it. Otherwise, use error message from axios itself
  return err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response = _err$response.data) !== null && _err$response !== void 0 && _err$response.message ? err.response.data.message : err.message;
}
function createPath(operation, params) {
  let path = operation;
  if (params && params.length > 0) {
    path = operation.concat("?".concat(params.join('&')));
  }
  return path;
}